// extracted by mini-css-extract-plugin
export default {"snackbar":"snackbar_snackbar__uqclR","fadeIn":"snackbar_fadeIn__LBG35","fadeOut":"snackbar_fadeOut__8JLC8"};